import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _observers, _mutationCache, _retryer, _dispatch;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/mutation.ts
import { notifyManager } from "./notifyManager.js";
import { Removable } from "./removable.js";
import { createRetryer } from "./retryer.js";
var Mutation = (_observers = /*#__PURE__*/new WeakMap(), _mutationCache = /*#__PURE__*/new WeakMap(), _retryer = /*#__PURE__*/new WeakMap(), _dispatch = /*#__PURE__*/new WeakSet(), /*#__PURE__*/function (_Removable) {
  _inherits(Mutation, _Removable);
  var _super = _createSuper(Mutation);
  function Mutation(config) {
    var _this;
    _classCallCheck(this, Mutation);
    _this = _super.call(this);
    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _dispatch);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _observers, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _mutationCache, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _retryer, {
      writable: true,
      value: void 0
    });
    _this.mutationId = config.mutationId;
    _classPrivateFieldSet(_assertThisInitialized(_this), _mutationCache, config.mutationCache);
    _classPrivateFieldSet(_assertThisInitialized(_this), _observers, []);
    _this.state = config.state || getDefaultState();
    _this.setOptions(config.options);
    _this.scheduleGc();
    return _this;
  }
  _createClass(Mutation, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
      this.updateGcTime(this.options.gcTime);
    }
  }, {
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      if (!_classPrivateFieldGet(this, _observers).includes(observer)) {
        _classPrivateFieldGet(this, _observers).push(observer);
        this.clearGcTimeout();
        _classPrivateFieldGet(this, _mutationCache).notify({
          type: "observerAdded",
          mutation: this,
          observer: observer
        });
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      _classPrivateFieldSet(this, _observers, _classPrivateFieldGet(this, _observers).filter(function (x) {
        return x !== observer;
      }));
      this.scheduleGc();
      _classPrivateFieldGet(this, _mutationCache).notify({
        type: "observerRemoved",
        mutation: this,
        observer: observer
      });
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      if (!_classPrivateFieldGet(this, _observers).length) {
        if (this.state.status === "pending") {
          this.scheduleGc();
        } else {
          _classPrivateFieldGet(this, _mutationCache).remove(this);
        }
      }
    }
  }, {
    key: "continue",
    value: function _continue() {
      var _classPrivateFieldGet2, _classPrivateFieldGet3;
      return (_classPrivateFieldGet2 = (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.continue()) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 :
      // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables);
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variables) {
        var _this2 = this,
          _this$options$retry;
        var restored, isPaused, _classPrivateFieldGet6, _classPrivateFieldGet7, _this$options$onSucce, _this$options2, _classPrivateFieldGet8, _classPrivateFieldGet9, _this$options$onSettl, _this$options3, _classPrivateFieldGet4, _classPrivateFieldGet5, _this$options$onMutat, _this$options, context, data, _classPrivateFieldGet10, _classPrivateFieldGet11, _this$options$onError, _this$options4, _classPrivateFieldGet12, _classPrivateFieldGet13, _this$options$onSettl2, _this$options5;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _classPrivateFieldSet(this, _retryer, createRetryer({
                fn: function fn() {
                  if (!_this2.options.mutationFn) {
                    return Promise.reject(new Error("No mutationFn found"));
                  }
                  return _this2.options.mutationFn(variables);
                },
                onFail: function onFail(failureCount, error) {
                  _classPrivateMethodGet(_this2, _dispatch, _dispatch2).call(_this2, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                  });
                },
                onPause: function onPause() {
                  _classPrivateMethodGet(_this2, _dispatch, _dispatch2).call(_this2, {
                    type: "pause"
                  });
                },
                onContinue: function onContinue() {
                  _classPrivateMethodGet(_this2, _dispatch, _dispatch2).call(_this2, {
                    type: "continue"
                  });
                },
                retry: (_this$options$retry = this.options.retry) !== null && _this$options$retry !== void 0 ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode,
                canRun: function canRun() {
                  return _classPrivateFieldGet(_this2, _mutationCache).canRun(_this2);
                }
              }));
              restored = this.state.status === "pending";
              isPaused = !_classPrivateFieldGet(this, _retryer).canStart();
              _context.prev = 3;
              if (restored) {
                _context.next = 12;
                break;
              }
              _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
                type: "pending",
                variables: variables,
                isPaused: isPaused
              });
              _context.next = 8;
              return (_classPrivateFieldGet4 = (_classPrivateFieldGet5 = _classPrivateFieldGet(this, _mutationCache).config).onMutate) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.call(_classPrivateFieldGet5, variables, this);
            case 8:
              _context.next = 10;
              return (_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables);
            case 10:
              context = _context.sent;
              if (context !== this.state.context) {
                _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
                  type: "pending",
                  context: context,
                  variables: variables,
                  isPaused: isPaused
                });
              }
            case 12:
              _context.next = 14;
              return _classPrivateFieldGet(this, _retryer).start();
            case 14:
              data = _context.sent;
              _context.next = 17;
              return (_classPrivateFieldGet6 = (_classPrivateFieldGet7 = _classPrivateFieldGet(this, _mutationCache).config).onSuccess) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.call(_classPrivateFieldGet7, data, variables, this.state.context, this);
            case 17:
              _context.next = 19;
              return (_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context);
            case 19:
              _context.next = 21;
              return (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(this, _mutationCache).config).onSettled) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, null, this.state.variables, this.state.context, this);
            case 21:
              _context.next = 23;
              return (_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context);
            case 23:
              _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
                type: "success",
                data: data
              });
              return _context.abrupt("return", data);
            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](3);
              _context.prev = 29;
              _context.next = 32;
              return (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = _classPrivateFieldGet(this, _mutationCache).config).onError) === null || _classPrivateFieldGet10 === void 0 ? void 0 : _classPrivateFieldGet10.call(_classPrivateFieldGet11, _context.t0, variables, this.state.context, this);
            case 32:
              _context.next = 34;
              return (_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, _context.t0, variables, this.state.context);
            case 34:
              _context.next = 36;
              return (_classPrivateFieldGet12 = (_classPrivateFieldGet13 = _classPrivateFieldGet(this, _mutationCache).config).onSettled) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.call(_classPrivateFieldGet13, void 0, _context.t0, this.state.variables, this.state.context, this);
            case 36:
              _context.next = 38;
              return (_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, _context.t0, variables, this.state.context);
            case 38:
              throw _context.t0;
            case 39:
              _context.prev = 39;
              _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
                type: "error",
                error: _context.t0
              });
              return _context.finish(39);
            case 42:
              _context.prev = 42;
              _classPrivateFieldGet(this, _mutationCache).runNext(this);
              return _context.finish(42);
            case 45:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 27, 42, 45], [29,, 39, 42]]);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return Mutation;
}(Removable));
function _dispatch2(action) {
  var _this3 = this;
  var reducer = function reducer(state) {
    switch (action.type) {
      case "failed":
        return _objectSpread(_objectSpread({}, state), {}, {
          failureCount: action.failureCount,
          failureReason: action.error
        });
      case "pause":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: true
        });
      case "continue":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: false
        });
      case "pending":
        return _objectSpread(_objectSpread({}, state), {}, {
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        });
      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        });
      case "error":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        });
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(function () {
    _classPrivateFieldGet(_this3, _observers).forEach(function (observer) {
      observer.onMutationUpdate(action);
    });
    _classPrivateFieldGet(_this3, _mutationCache).notify({
      mutation: _this3,
      type: "updated",
      action: action
    });
  });
}
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
export { Mutation, getDefaultState };